import {
  HOME_DEPOT_DEV
} from "../constants/urls";

export const setUrl = (domain, pathName) => window?.location.assign(domain + pathName); // eslint-disable-line no-return-assign

/**
 * returns if the host is a HD dev or stage environment
 * @returns {boolean}
 */
export const isLLC = () => window?.location.host.includes(HOME_DEPOT_DEV);

export const getAllUrlParams = () => {
  const searchParams = (typeof window !== "undefined") ? window?.location?.search : "";
  const urlParams = new URLSearchParams(searchParams);
  return urlParams;
};

export const getUrlParam = (key) => {
  const searchParams = (typeof window !== "undefined") ? window?.location?.search : "";
  const urlParams = new URLSearchParams(searchParams);
  return urlParams.get(key);
};

export const TERMS_OF_USE_URL = "https://www.homedepot.com/c/Terms_of_Use";

export const PRIVACY_AND_SECURITY_STATEMENT_URL = "https://www.homedepot.com/privacy/privacy-and-security-statement";